/**************logo-showcase (HOMEPAGE + PDP) slick******************/
$(function(){
  $(document).ready(function(){ 
    // console.log("Test");
    $('.cst_logo_slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      dots: true,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false
    });
    
    
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    fade: false,
    asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: true,
    centerMode: true,
    focusOnSelect: true
  });
    $('.slideReview').slick({
      autoplay:true,
      speed: 700,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '0',
      prevArrow: '<svg focusable="false" role="presentation" class="icon icon-arrow-left left-arrow slick-arrow" viewBox="0 0 32 32" style="display: flex; color: var(--base-colour, #672666);"><path fill="currentColor" d="M24.333 28.205l-1.797 1.684L7.666 16l14.87-13.889 1.797 1.675L11.269 16z"></path></svg>',
      nextArrow: '<svg focusable="false" role="presentation" class="icon icon-arrow-right right-arrow slick-arrow" viewBox="0 0 32 32" style="display: flex; color: var(--base-colour, #672666);"><path fill="currentColor" d="M7.667 3.795l1.797-1.684L24.334 16 9.464 29.889l-1.797-1.675L20.731 16z"></path></svg>',
      responsive: [
      	{
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
            centerMode: true,
            centerPadding: '0%',
            dots: true
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '0%',
            dots: true
          }
        }
      ]
    });

  });
  
});

const productCards = document.querySelectorAll(".product-item");
productCards.forEach(card => {
  const subBoxes = card.querySelector(".subscription-boxes")
  const oneTimeBox = card.querySelector(".one-time-box")
  const sellingPlanInput = card.querySelector("[name='selling_plan']")
  const subscriptionSelect = card.querySelector("[data-subscription-select]")
  const sellingTypeDisplay = card.querySelector("[data-selling-plan-type]")
  const quantityInput = card.querySelector("[data-quantity-input]")
  const quantityDec = card.querySelector("[data-quantity-dec]")
  const quantityInc = card.querySelector("[data-quantity-inc]")

  if (subBoxes) {
    subBoxes.addEventListener("click", function() {
      if (oneTimeBox) oneTimeBox.classList.remove("selected");
      subBoxes.classList.add("selected")
      if (sellingPlanInput && subscriptionSelect) sellingPlanInput.value = subscriptionSelect.value;
      if (sellingTypeDisplay) sellingTypeDisplay.innerText = "Subscription"
    })
  }

  if (oneTimeBox) {
    oneTimeBox.addEventListener("click", function() {
      oneTimeBox.classList.add("selected");
      if (subBoxes) subBoxes.classList.remove("selected")
      if (sellingPlanInput) sellingPlanInput.value = null;
      if (sellingTypeDisplay) sellingTypeDisplay.innerText = "One Time"
    })
  }

  if (subscriptionSelect) {
    subscriptionSelect.addEventListener("change", function() {
      if (sellingPlanInput) sellingPlanInput.value = this.value;
      const priceElement = card.querySelector("[data-subscribe-price]");
      if (priceElement) priceElement.innerText = this.options[this.selectedIndex].dataset.price;
    })
  }

  if (quantityDec && quantityInput) {
    quantityDec.addEventListener("click", function() {
      if (quantityInput.value > 1) quantityInput.value = Number(quantityInput.value) - 1;
    })
  }

  if (quantityInc && quantityInput) {
    quantityInc.addEventListener("click", function() {
      quantityInput.value = Number(quantityInput.value) + 1;
    })
  }
})